import { Fade } from "@/components/Reveal";

export const SectionLabel = ({ num, name }: { num: string; name: string }) => (
  <Fade className="flex items-center gap-4" y={16}>
    <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-mute">
      {num} — {name}
    </span>
    <span className="h-px w-16 bg-line" />
  </Fade>
);

export default SectionLabel;
